import useSWR from 'swr';
import { AdminSettingsService } from '@/services/engine/admin-settings-service';
import type { OrganizationSettings } from '@/types/admin-settings';

const CACHE_KEY = 'admin-organization-settings';

export function useOrganizationSettings() {
    const { data, isLoading, error, mutate } = useSWR<OrganizationSettings>(
        CACHE_KEY,
        () => AdminSettingsService.getOrganizationSettings(),
        { revalidateOnFocus: false },
    );

    return { organization: data, isLoading, error, mutate };
}
